import { PaymentSubmissionModalType } from './payment-submission-modal.type';

export const getModalTitle = (type: PaymentSubmissionModalType) => {
  switch (type) {
    case PaymentSubmissionModalType.PaymentSubcategory:
      return 'Payment Subcategory';
    default:
      return 'Payment Category';
  }
};
